export const SocketEvents = {
  publish: {
    client: {
      event: 'client:event',
      actions: {
        user: {
          presence: {
            changed: 'client:user:presence:changed'
          }
        }
      }
    }
  },
  subscribe: {
    all: {
      event: 'server:event:all',
      actions: {
        notify: "server:event:notification",
      }
    },
    signedIn: {
      event: 'server:event:signedIn',
      actions: {
        heartbeat: 'server:event:heartbeat',
        notify: 'server:event:notification',
      }
    },
    user: {
      event: 'server:event:user',
      actions: {
        notify: 'server:event:notification',
        user: {
          presence: {
            changed: 'server:event:user:presence:changed',
          },
          profile: {
            saved: 'server:event:user:profile:saved',
          }
        }
      }
    },
    device: {
      event: 'server:event:device',
      actions: {
        notify: 'server:event:notification',
        user: {
          presence: {
            changed: 'server:event:user:presence:changed',
          }
        }
      }
    },
    other: {
      users: {
        event: 'server:event:other:users',
        actions: {
          user: {
            presence: {
              changed: 'server:event:user:presence:changed',
            }
          }
        }
      },
      devices: {
        event: 'server:event:other:devices',
        actions: {
        }
      }
    }
  }
};
